var _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgClasses(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 500,
    height: 407,
    viewBox: "0 0 500 407",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "parent",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M395.997 404.31C451.457 404.31 496.416 359.351 496.416 303.891C496.416 248.431 451.457 203.472 395.997 203.472C340.537 203.472 295.578 248.431 295.578 303.891C295.578 359.351 340.537 404.31 395.997 404.31ZM450.23 278.421C454.65 273.117 453.933 265.235 448.63 260.815C443.326 256.396 435.444 257.112 431.025 262.416L383.999 318.846L360.205 295.052C355.323 290.171 347.409 290.171 342.527 295.052C337.646 299.934 337.646 307.848 342.527 312.73L374.452 344.654L374.488 344.691C374.697 344.904 375.611 345.835 376.621 346.598C377.998 347.639 381.049 349.565 385.384 349.369C389.718 349.172 392.583 346.978 393.86 345.816C394.796 344.964 395.622 343.955 395.811 343.724L395.844 343.684L450.23 278.421Z",
    fill: "#594AD7"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    className: "parent",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M147.747 353.774L147.747 353.774C81.4134 302.667 3.50278 242.64 3.50278 138.582C3.50278 23.708 133.429 -57.7582 239.726 52.68L286.971 99.8928C293.89 106.81 305.108 106.808 312.027 99.8881C318.943 92.9681 318.941 81.7506 312.022 74.833L266.384 29.211C366.542 -44.1134 475.949 33.1685 475.949 138.582C475.949 163.477 471.49 185.852 463.796 206.188C444.56 192.829 421.194 185 396 185C330.278 185 277 238.278 277 304C277 331.478 286.313 356.78 301.955 376.924C280.815 393.231 260.271 407 239.726 407C216.104 407 192.481 388.797 167.955 369.462C161.43 364.317 154.68 359.116 147.805 353.819L147.747 353.774Z",
    fill: "#F22B5D"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgClasses);
export default __webpack_public_path__ + "static/media/classes.baacf94c13f67353f70a39f1d61ab82b.svg";
export { ForwardRef as ReactComponent };